import React from 'react';

// Content identity survives inserting/reordering unrelated legal blocks. A local
// occurrence suffix disambiguates identical fragments without global indices.
const keyed = values => {
  const occurrences = new Map();
  return values.map(value => {
    const identity = JSON.stringify(value);
    const occurrence = occurrences.get(identity) || 0;
    occurrences.set(identity, occurrence + 1);
    return { value, key: `${identity}:${occurrence}` };
  });
};
// React escapes the approved text; no supplied HTML or arbitrary URL executes.
const emails = text => text.split(/(hello@cubitplay\.com|privacy@cubitplay\.com)/g);
const InlineText = ({ text, prefix }) => <>{keyed(text.split('\n')).map(({ value: line, key }, lineIndex, lines) => <React.Fragment key={key}>
  {keyed(line.split(/(\*\*[^*]+\*\*)/g)).map(({ value: part, key: partKey }, partIndex) => {
    const strong = part.startsWith('**') && part.endsWith('**');
    const content = strong ? part.slice(2, -2) : part;
    const rendered = keyed(emails(content)).map(({ value: piece, key: pieceKey }, index) => /^(hello|privacy)@cubitplay\.com$/.test(piece)
      ? <a key={pieceKey} href={`mailto:${piece}`} data-testid={`${prefix}-email-${lineIndex}-${partIndex}-${index}`}>{piece}</a>
      : piece);
    return strong ? <strong key={partKey}>{rendered}</strong> : <React.Fragment key={partKey}>{rendered}</React.Fragment>;
  })}
  {lineIndex < lines.length-1 && (line.endsWith('  ') ? <br/> : ' ')}
</React.Fragment>)}</>;

export const LegalBlocks = ({ blocks, prefix, preamble = false }) => <>{keyed(blocks).map(({ value: block, key }, index) => {
  const id = `${prefix}-block-${index+1}`;
  if (block.type === 'list') return <ul key={key} data-testid={id}>{keyed(block.items).map(({ value: text, key: itemKey }, item) => <li key={itemKey} data-testid={`${id}-item-${item+1}`}><InlineText text={text} prefix={`${id}-item-${item+1}`}/></li>)}</ul>;
  if (block.type === 'heading') return <h3 key={key} data-testid={id}><InlineText text={block.text} prefix={id}/></h3>;
  return <p key={key} data-testid={preamble && index === 0 ? 'legal-page-effective-date' : id}><InlineText text={block.text} prefix={id}/></p>;
})}</>;
